/** @jsxImportSource @emotion/react */
import differenceInYears from 'date-fns/differenceInYears';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { FormDob, useTrackedFormik } from '@omnigenbiodata/ui';

export interface AuthIdentifyFormProps {
  onsubmit?: (values: any) => void;
}

function AuthIdentifyForm({ onsubmit }: AuthIdentifyFormProps) {
  const { t } = useTranslation('portal');
  const validationSchema = yup.object().shape({
    dob: yup
      .string()
      .test('dob', t('forms.dob.msg.minAge') as string, function (value) {
        return differenceInYears(new Date(), new Date(value || '')) >= 18;
      })
      .required(t('forms.dob.msg.required') as string),
  });

  const formik = useTrackedFormik(
    {
      initialValues: { firstName: '', surname: '', dob: '' },
      validationSchema,
      onSubmit: (values: any) => {
        if (onsubmit) {
          onsubmit(values);
        }
      },
    },
    'auth-identify',
  );

  return (
    <form onSubmit={formik.handleSubmit}>
      <Box mb={5}>
        <FormDob
          error={formik.errors.dob}
          name="dob"
          label={t('forms.dob.label') as string}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          touched={formik.touched.dob}
          value={formik.values.dob}
          setValue={formik.setFieldValue}
          minAge={18}
        />
      </Box>
      <Box>
        <Button data-testid="register-button" size="large" fullWidth variant="contained" color="primary" type="submit">
          {t('buttons.register')}
        </Button>
      </Box>
    </form>
  );
}

export default AuthIdentifyForm;
